import { Preview } from "@creatomate/preview";
import { ElementSource } from "chq";

const applyModificationsNoUndo = async (modifications: ElementSource, preview: Preview) => {
  const source = preview.getSource();
  const updatedElements = source.elements.map((element: ElementSource) => ({
    ...element,
    ...(modifications.elements?.[element.id] || {})
  }));

  await preview.setSource({
    ...source,
    ...modifications,
    elements: updatedElements
  }, false);
};

export default applyModificationsNoUndo;
